import React from 'react';
import ReactDOM from 'react-dom/client';
import { createHashRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import ThemeProvider from './components/ThemeProvider';
import './index.css';
import './pro.css';

const router = createHashRouter([{ path: '*', element: <ThemeProvider><App /></ThemeProvider> }], { future: { v7_relativeSplatPath: true } });
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode><RouterProvider router={router} future={{ v7_startTransition: true }} /></React.StrictMode>
);
